/**
 * About component
 *
 * Space for you to describe more about yourself.
 */

import React from "react";

/**
 * About background image
 *
 * Below is a sample image. Upload the image of your choice into the "images"
 * directory and import here for use. Then, set imageAltText to string that
 * represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a image you
 * freely use on your site.
 */
import image from "../images/kenya-background.jpg";

const imageAltText = "a generic safari background";

/**
 * Sort description that expands on your title on the Home component.
 */
const description =
  "I'm a Computer Science student with a passion for AI and Blockchain technology, and a deep love for wildlife conservation. Raised in Nairobi, Kenya, I'm driven to use my skills to make a positive impact on wildlife preservation efforts by incorporating innovative technology solutions. ";

/**
 * List of some of skills or technologies you work on, are learning,
 * passionate about, or enjoy,
 */
const skillsList = [
  "Blockchain Technology",
  "Artificial Intelligence",
  "Wildlife Conservation",
  "Web Development",
  "Non-Fungible Tokens",
  "Decentralized Finance",
];

/**
 * Use this to give more information about what you are passionate about,
 * how you best work, or even a quote. This will help someone learn more
 * about you on a professional level.
 */
const detailOrQuote =
  "We can now destroy or we can cherish: the choice is ours. Technology has brought with it the means to destroy, but it can also provide us with innovative solutions to protect and preserve the natural world. ~ Sir David Attenborough";

const About = () => {
  return (
    <section className="light" id="about">
      <img className="background" src={image} alt={imageAltText} />
      <div
        style={{
          backgroundColor: "white",
          width: "50%",
          padding: "4rem",
          margin: "3rem auto",
          textAlign: "center",
        }}
      >
        <h2>About Myself</h2>
        <p className="large">{description}</p>
        <hr />
        <ul
          style={{
            textAlign: "left",
            columns: 2,
            fontSize: "1.25rem",
            margin: "2rem 3rem",
            gap: "3rem",
          }}
        >
          {skillsList.map((skill) => (
            <li key={skill}>{skill}</li>
          ))}
        </ul>
        <hr />
        <p style={{ padding: "1rem 3rem 0" }}>{detailOrQuote}</p>
      </div>
    </section>
  );
};

export default About;
